import { useState, useCallback } from 'react';

type ShareData = {
  title: string;
  url: string;
};

const isSupported =
  typeof navigator !== 'undefined' && 'share' in navigator;

export default function useShare() {
  const [isSharing, setIsSharing] = useState(false);

  const share = useCallback(
    async (data: ShareData) => {
      if (isSharing || !isSupported) return;
      setIsSharing(true);
      try {
        await navigator.share(data);
      } catch (e) {
        if (e instanceof Error && e.name !== 'AbortError') throw e;
      } finally {
        setIsSharing(false);
      }
    },
    [isSharing],
  );

  return { share, isSharing, isSupported };
}
